import { SwapWidget as PrestyledSwapWidget } from '@uniswap/widgets'
import React from 'react'
import { Medium } from 'streamr-ui/css/consts'
import styled from 'styled-components'
import uniswap from '~shared/PersonaPage/assets/uniswap.png'
import uniswap2x from '~shared/PersonaPage/assets/uniswap@2x.png'

const {
    GATSBY_UNISWAP_TOKEN_LIST_URL:
        tokenList = 'http://localhost:8080/resources/json/tokenlist.json',
} = process.env

const theme = {
    module: '#f5f5f5',
    fontFamily: {
        font: '"IBM Plex Sans", Inter, sans-serif',
    },
}

const defaultOutputTokenAddress = {
    1: '0x8f693ca8d21b157107184d29d398a8d082b38b76',
    137: '0x3a9A81d576d83FF21f26f325066054540720fC34',
}

export default function UniswapWidget() {
    return (
        <Root>
            <Header>
                <ImageWrap>
                    <img src={uniswap} srcSet={`${uniswap2x} 2x`} alt="Uniswap" />
                </ImageWrap>
                <Title>Exchange on Uniswap</Title>
            </Header>
            <SwapWidget
                width="100%"
                theme={theme}
                defaultOutputTokenAddress={defaultOutputTokenAddress}
                tokenList={tokenList}
            />
        </Root>
    )
}

const SwapWidget = styled(PrestyledSwapWidget)`
    background: transparent;
    border-radius: 0;
    border: 0;
    box-shadow: none;
    min-width: 0;
    padding: 0;

    [color='container'] > div > div:nth-child(3) {
        position: relative;
    }
`

const Root = styled.div`
    background: #ffffff;
    border-radius: 0.5rem;
    box-shadow: 0px 6.30704px 50px -6.30704px rgba(0, 0, 0, 0.1);
    font-weight: ${Medium};
    line-height: 1.375rem;
    text-decoration: none !important;
    transition: box-shadow 200ms ease-in-out;
    padding: 2rem;
    padding-bottom: 2.5rem;
`

const Header = styled.div`
    align-items: center;
    display: flex;
    margin-bottom: 2rem;
`

const ImageWrap = styled.div`
    aligh-items: center;
    display: flex;
    flex-shrink: 0;
    height: 2.5rem;
    justify-content: center;
    margin-right: 1.5rem;
    width: 2.5rem;
`

const Title = styled.div`
    font-size: 1.5rem;
    flex-grow: 1;
`
